import { BiLinkExternal } from "react-icons/bi";
import { AiFillGithub } from "react-icons/ai";

import { IconLink } from "../UI/IconLink/IconLink";
import styles from "./PortfolioItem.module.css";
import Arrow from "../UI/Arrow/Arrow";

export const PortfolioItem = ({
  portfolioActiveIndex,
  project,
  activeImageIndex,
  setActiveImageIndex,
  openModalHandler,
}) => {
  const { images, name, description, demo, github, tools } = project;

  const onArrowClickHandler = (dir) => {
    const len = images.length - 1;
    if (dir === "left")
      setActiveImageIndex((prev) => (prev === 0 ? len : prev - 1));
    else setActiveImageIndex((prev) => (prev === len ? 0 : prev + 1));
  };

  return (
    <li
      className={styles.project}
      style={{ transform: `translateX(${portfolioActiveIndex * -100}%)` }}
    >
      <div className={styles["images-slider-container"]}>
        <Arrow arrowDirection="left" onClick={onArrowClickHandler} />
        {images.map((item, index) => (
          <div
            key={index}
            onClick={openModalHandler}
            style={{ opacity: activeImageIndex === index ? 1 : 0 }}
            className={styles["image-slider-item-container"]}
          >
            <img src={item} alt={name} style={{ objectFit: "contain" }} />
          </div>
        ))}
        <Arrow arrowDirection="right" onClick={onArrowClickHandler} />
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{name}</h3>
        <p className={styles.description}>{description}</p>
        <div className={styles.tools}>
          {tools.map((tool, idx) => (
            <span key={idx} className={styles.tool}>
              {tool}
            </span>
          ))}
        </div>

        <div className={styles.links}>
          {demo && (
            <IconLink
              to={demo}
              text="Demo"
              Icon={BiLinkExternal}
              isExternal={true}
              aria-label="demo link"
              className={styles.link}
            />
          )}
          {github && (
            <IconLink
              to={github}
              text="GitHub"
              Icon={AiFillGithub}
              isExternal={true}
              aria-label="logo github"
              className={styles.link}
            />
          )}
        </div>
      </div>
    </li>
  );
};
